import * as jose from 'jose';

const PRODUCTLIFT_SSO_SECRET = import.meta.env.VITE_PRODUCTLIFT_SSO_SECRET;

export type ProductLiftUserData = {
  email: string;
  uid: string;
  name: string;
  avatar_url?: string;
  company?: string;
  segment_1?: string;
  segment_2?: string;
  segment_3?: string;
  mrr?: string;
  arr?: string;
  ltv?: string;
};

export const generateProductLiftToken = async (userData: ProductLiftUserData): Promise<string> => {
  if (!PRODUCTLIFT_SSO_SECRET) {
    throw new Error('ProductLift SSO secret is not configured');
  }

  const secret = new TextEncoder().encode(PRODUCTLIFT_SSO_SECRET);
  return await new jose.SignJWT(userData)
    .setProtectedHeader({ alg: 'HS256' })
    .sign(secret);
};

export const getProductLiftUrl = async (userData: ProductLiftUserData, path: string = ''): Promise<string> => {
  const token = await generateProductLiftToken(userData);
  const baseUrl = 'https://feedback.storymuse.io/new';
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${baseUrl}/${cleanPath}?sso=${token}`;
};